import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authRegisterUser, authLoginUser, logoutUser } from "../../api/authApi";

// Get user from localStorage
const user = JSON.parse(localStorage.getItem("user"));

const initialState = {
  user: user ? user : null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    loadUser(state, action) {
      state.isLoading = true;
    },
    registerSuccess(state, action) {
      state.isLoading = false;
      state.isSuccess = true;
      state.user = action.payload;
    },
    registerFail(state, action) {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
      state.user = null;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
    },
    loginFail(state, action) {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
      state.user = null;
    },
    reset(state, action) {
      state.isLoading = false;
      state.isSuccess = false;
      state.user = null;
      state.isError = false;
      state.message = "";
    },
  },
});

export const {
  loadUser,
  registerSuccess,
  registerFail,
  loginSuccess,
  loginFail,
  reset,
} = authSlice.actions;

export const selectAuth = (state) => state.auth.user;

// Register User
export const registerUser = (user) => async (dispatch) => {
  try {
    dispatch(loadUser());

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const userData = await authRegisterUser(user, config);
    dispatch(registerSuccess(userData));
  } catch (error) {
    dispatch(registerFail(error));
  }
};

// Login User
export const loginUser = (user) => async (dispatch) => {
  try {
    dispatch(loadUser());

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const userData = await authLoginUser(user, config);
    dispatch(loginSuccess(userData));
  } catch (error) {
    dispatch(loginFail(error));
  }
};

// Logout User
export const logout = createAsyncThunk("auth/logout", async () => {
  await logoutUser();
});

export default authSlice.reducer;
